'use strict';

import {gsap} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

const init = () => {
    gsap.registerPlugin(ScrollTrigger)

    const body = document.querySelector('body')
    const movement = parseInt(body.dataset.scrollRevealMovement) || 120
    const duration = parseFloat(body.dataset.scrollRevealDuration) || 0.4
    const once = body.dataset.scrollRevealOnce === 'true'
    const className = body.dataset.scrollRevealClassName || 'tc-animations-scroll-reveal'

    gsap.utils.toArray('.' + className).forEach((element) => {
        const anim = gsap.fromTo(element, {autoAlpha: 0, y: movement}, {duration: duration, autoAlpha: 1, y: 0})

        ScrollTrigger.create({
            trigger: element,
            animation: anim,
            toggleActions: once ? "play none none none" : "play none none reverse"
        })
    })
}

export default {init};
